
import React, { useState } from 'react'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import GSSVG from 'smartstream-widgets/controls/GSSVG'
import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'

type Props = {
  title: string,
  anchorEl: HTMLDivElement | (() => HTMLDivElement),
  closeIcon: string,
  openIcon: string,
  openButtonViewBox?: string,
  classes: {
    [K in string]: string
  },
  children?: React.ReactNode
}

const styles = (theme: Theme) => createStyles({
  modal: {
    width: '100%'
  },
  modalInner: {
    right: 0,
    maxWidth: 'none',
    padding: theme.spacing(2, 1.5)
  },
  title: {
    marginBottom: theme.spacing(1.5)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(2)
  },
  closeButtonIcon: {
    color: theme && theme.palette.grey['600'],
    verticalAlign: 'bottom'
  },
  openButton: {
    color: theme && theme.palette.grey['600'],
    verticalAlign: 'bottom'
  },
  iconWrapper: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    lineHeight: 1,
    margin: 0,
    padding: 0,
    '&:active, &:focus': {
      outline: 'none'
    }
  }
})

export function HelperInfo(props: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const { classes, title, children, anchorEl, closeIcon, openIcon, openButtonViewBox = '0 0 10 14' } = props

  return (
    <>
      <button
        className={classes.iconWrapper}
        data-ht-category='helper-info'
        data-ht-action='open'
        data-testid='helper-info-button'
      >
        <GSSVG onClick={() => { setIsOpen(true) }} className={classes.openButton} viewBox={openButtonViewBox} xlinkHref={openIcon} />
      </button>
      <Popover
        marginThreshold={0}
        classes={{ root: classes.modal, paper: classes.modalInner }}
        open={isOpen}
        style={anchorEl && { position: 'absolute' }}
        container={anchorEl || null}
        anchorReference='anchorPosition'
        anchorPosition={{ left: 0, top: 0 }}
        onClose={() => { setIsOpen(false) }}
        elevation={2}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <button
          className={`${classes.iconWrapper} ${classes.closeButton}`}
          data-ht-category='helper-info'
          data-ht-action='close'
        >
          <GSSVG
            className={classes.closeButtonIcon}
            onClick={() => { setIsOpen(false) }}
            viewBox={'0 0 10 14'}
            xlinkHref={closeIcon} />
        </button>
        <Typography className={classes.title}>
          {title}
        </Typography>
        {children}
      </Popover>
    </>
  )
}

export default withStyles(styles, { name: 'HelperInfo', defaultTheme: getDefaultTheme })(HelperInfo)
